module.exports = __webpack_public_path__ + "img/c07_unittechaxemanchampion_Normal_ua.aef52cb9.webp";